import React, { createContext, useContext, useState } from "react"

import EnhancedSearchDialog from "../components/enhanced-search/EnhancedSearchDialog"

const GlobalSearchContext = createContext()

export const useSearch = () => useContext(GlobalSearchContext)

const GlobalSearchProvider = ({ children }) => {
  const [open, setOpen] = useState(false)

  const openSearch = () => {
    setOpen(true)
  }

  const closeSearch = () => {
    setOpen(false)
  }

  return (
    <GlobalSearchContext.Provider value={{ openSearch, closeSearch }}>
      <EnhancedSearchDialog open={open} onClose={closeSearch} />
      {children}
    </GlobalSearchContext.Provider>
  )
}

export default GlobalSearchProvider